// src/hooks/programs/useRestoreAllPrograms.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllPrograms } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useRestoreAllPrograms = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllProgramsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: restoreAllPrograms,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore programs");
        },
    });

    return {
        restoreAllProgramsMutate,
        isPending: isPending || isLoading,
    };
};

export default useRestoreAllPrograms;
